<section class="dsm-flex-container shareable-cart-container">
    <div *ngIf="busy" class="flex-row">
        <usana-spinner [show]="busy" [delay]="100"></usana-spinner>
    </div>
    <div class="panel-container" *ngIf="!busy">
        <div class="panel intro word-wrap">
            <div class="card text-center" *ngIf="!!shareableProducts">
                <h1 class="category-hero-title heading-2" translate="cart.shareable.landing.intro.title"></h1>
                <p>{{headerDescription}}</p>
                <p *ngIf="showSignup" translate="cart.shareable.landing.intro.description.sign.up"></p>
                <button *ngIf="showSignup" class="button button-primary button-large" [routerLink]="ENROLL_PC_INFO_ROUTE"
                        translate="cart.enroll.sign.up"></button>
            </div>
            <div class="card text-center" *ngIf="!shareableProducts">
                <h1 class="category-hero-title heading-2" translate="cart.shareable.landing.error"></h1>
            </div>
            <img src="/image-service/ws/imgs/file/4993722/aws/w/0/h/0.img" alt="" height="104px">
        </div>
        <ng-container *ngIf="!!shareableProducts">
            <div class="panel product-panel" *ngFor="let shareProduct of shareableProducts; trackBy: trackByFn">
                <product-results-card [usanaId]="shareProduct.usanaId" [productGroup]="shareProduct.productGroup"
                                      [productShareQty]="shareProduct.quantity">
                </product-results-card>
            </div>
        </ng-container>
        <div class="panel outro word-wrap" *ngIf="!!shareableProducts && (showCart || showSignup)">
            <div *ngIf="showCart" class="card text-center">
                <h3 class="category-hero-title heading-2" translate="cart.shareable.landing.outro.title"></h3>
                <button class="button button-primary button-large" [routerLink]="CART_OVERVIEW_ROUTE"
                        [disabled]="!productsInCart"
                        translate="cart.continue.checkout"></button>
                <button class="button button-tertiary button-large"
                        [routerLink]="[CATALOG_ROUTE, -1]"
                        translate="cart.explore.products"></button>
            </div>
            <div *ngIf="showSignup" class="card text-center">
                <h3 class="category-hero-title heading-2" translate="cart.shareable.landing.outro.title.sign.up"></h3>
                <button class="button button-primary button-large" [routerLink]="ENROLL_PC_INFO_ROUTE"
                        translate="cart.enroll.sign.up"></button>
            </div>
        </div>
    </div>
</section>
